import { Avatar, lucideIcons, Spinner } from '@round/creatorbase-ui';
import { SoundChipState } from './useSoundChips';
import styles from './SoundTargets.module.css';

const { Music2 } = lucideIcons;

type Props = {
    chip: SoundChipState;
};

/**
 * Two states and no more: what was typed while the sound is being looked up, and the sound itself
 * once it has been. A chip that cannot resolve is removed rather than shown as broken.
 */
export const SoundChip = ({ chip }: Props) => {
    if (!chip.audio) {
        return (
            <span className={styles.chip}>
                <Spinner className={styles.spinner} />
                <span className={styles.identifier}>{chip.identifier}</span>
            </span>
        );
    }

    return (
        <span className={styles.chip}>
            <Avatar size="sm" className={styles.cover}>
                <Avatar.Image src={chip.audio.cover_thumb} alt="" />
                <Avatar.Fallback>
                    <Music2 className={styles.coverIcon} />
                </Avatar.Fallback>
            </Avatar>

            <span className={styles.title}>{getSoundName(chip)}</span>
            {chip.audio.author_name && <span className={styles.author}>{chip.audio.author_name}</span>}
        </span>
    );
};

/**
 * A sound Round has only just been told about has nothing scraped against it yet, so the chip falls
 * back to what was pasted rather than showing an empty title.
 */
export const getSoundName = (chip: SoundChipState) => chip.audio?.title || chip.identifier;
